export class MsCal {
    static MSAL_SERVICE_SS_KEY = "SERVICE_MSAL_TOKEN";
}
